import React, { useEffect, useMemo, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { GeneralApi } from "../../Api/General";
import { QuizAPI } from "../../Api/Quiz";
import { Button, Input, UploadButton } from "../../Components/CustomComponent";
import { useAppContext } from "../../Context/AppContext";
import { formatDate } from "../../Helper";
import { Toast } from "../../Hooks/useToast";
import styles from "./index.module.scss";

export default function UpdateQuiz() {
  const quizAPI = QuizAPI();
  const generalApi = GeneralApi();
  const navigate = useNavigate();
  const { selectedQuiz } = useAppContext();
  const location = useLocation();
  const isMultileFileUpload = useMemo(() => false, []);
  const fileAcceptParams = useMemo(() => "image/png, image/jpeg", []);
  const [file, setFile] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [coverImageUrl, setCoverImageUrl] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    start_at: "",
    end_at: "",
    contestant_count: "",
    audience_count: "",
    audience_poll_duration: "",
    expert_help_duration: "",
    google_help_duration: "",
    cover_image_url: "",
  });

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const quiz = useMemo(() => location.state?.quiz, [location.state?.quiz]);

  const quizMutation = useMutation(quizAPI.create, {
    onSuccess: (data) => {
      Toast("Quiz created successfully!", "success", false);
      reset();
      setFile(null);
      setImageFiles([]);
      navigate(-1);
    },
    onError: (err) => {
      if (err.code === 400) {
        Toast(err.message, "error", false);
      } else {
        Toast("Something went wrong!", "error", false);
      }
    },
  });

  const uploadMutation = useMutation(generalApi.upload, {
    onSuccess: (data) => {
      const imageUrl = data?.data[0];
      setFile(imageUrl);
      Toast("Image uploaded successfully!", "success", false);
      setLoading(false);
      Reset();
    },
    onError: (err) => {
      Toast(err.message, "error", false);
      setLoading(false);
    },
  });

  const upload = async (image) => {
    let formData = new FormData();
    formData.append("file", image);
    formData.append("path", "quizzes");
    uploadMutation.mutate(formData);
  };

  const handleAddfilesAndSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCoverImageUrl(null);
      setFile(file);
      const doc = URL.createObjectURL(file);
      setImageFiles([...imageFiles, doc]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const Reset = () => {
    reset({
      title: "",
      description: "",
      contestant_count: "",
      audience_count: "",
      audience_poll_duration: "",
      expert_help_duration: "",
      google_help_duration: "",
      cover_image_url: "",
    });
  };

  useEffect(() => {
    if (quiz) {
      setValue("title", quiz.title);
      setValue("description", quiz.description);
      setValue("contestant_count", quiz.contestant_count);
      setValue("audience_count", quiz.audience_count);
      setValue("audience_poll_duration", quiz.audience_poll_duration);
      setValue("expert_help_duration", quiz.expert_help_duration);
      setValue("google_help_duration", quiz.google_help_duration);
      setValue("cover_image_url", quiz.cover_image_url);
      setCoverImageUrl(quiz.cover_image_url);
      setValue("start_at", formatDate(quiz.start_at));
      setValue("end_at", formatDate(quiz.end_at));
    }
  }, [quiz]);

  const onSubmit = async (data) => {
    if (loading) return;

    if (file) {
      setLoading(true);
      const formDataForUpload = new FormData();
      formDataForUpload.append("file", file);
      formDataForUpload.append("path", "quizzes");

      const uploadResponse = await uploadMutation.mutateAsync(
        formDataForUpload
      );
      data.cover_image_url = uploadResponse?.data[0];
    }
      await quizMutation.mutateAsync(data);
  };

  // const onSubmit = async (e) => {
  //   e.preventDefault();

  //   if (
  //     !formData.title ||
  //     !formData.description ||
  //     !formData.start_at ||
  //     //   !formData.start_time ||
  //     !formData.end_at ||
  //     //   !formData.end_time ||
  //     !formData.contestant_count ||
  //     !formData.audience_count ||
  //     !formData.audience_poll_duration ||
  //     !formData.expert_help_duration ||
  //     !formData.google_help_duration
  //   ) {
  //     Toast("Please fill all required fields", "error", false);
  //     return;
  //   }

  //   try {
  //     let imageUrl = formData.cover_image_url;

  //     if (file) {
  //       const formDataForUpload = new FormData();
  //       formDataForUpload.append("file", file);
  //       formDataForUpload.append("path", "quizzes");

  //       const uploadResponse = await uploadMutation.mutateAsync(
  //         formDataForUpload
  //       );
  //       imageUrl = uploadResponse?.data[0];
  //     }

  //     const body = {
  //       title: formData.title,
  //       description: formData.description,
  //       start_at: `${formData.start_at} ${formData.start_time}`,
  //       end_at: `${formData.end_at} ${formData.end_time}`,
  //       contestant_count: parseInt(formData.contestant_count, 10),
  //       audience_count: parseInt(formData.audience_count, 10),
  //       audience_poll_duration: parseInt(formData.audience_poll_duration, 10),
  //       expert_help_duration: parseInt(formData.expert_help_duration, 10),
  //       google_help_duration: parseInt(formData.google_help_duration, 10),
  //       cover_image_url: imageUrl,
  //     };
  //     await quizMutation.mutateAsync(body);

  //     Toast("Quiz created successfully!", "success", false);
  //   } catch (error) {
  //     Toast(error.message, "error", false);
  //   }
  // };

  return (
    <Container className={styles.CreateQuiz}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col sm={12}>
            <UploadButton
              label="Upload Cover"
              classes="mb-2"
              labelClasses="p-5"
              isMultileFileUpload={isMultileFileUpload}
              fileAcceptParams={fileAcceptParams}
              file={file}
              handleFileChange={handleAddfilesAndSelect}
              cover_image_url={coverImageUrl}
            />
          </Col>

          <Col sm={12}>
            <Controller
              name="title"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Quiz Title"
                  placeholder="Add Here"
                  errors={errors}
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="contestant_count"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Contestant"
                  placeholder="1 - 99"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="audience_count"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Audience Count"
                  placeholder="1 - 99"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="start_at"
              control={control}
              render={({ field }) => (
                <Input {...field} label="Start Date" type="date" />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="end_at"
              control={control}
              render={({ field }) => (
                <Input {...field} label="End Date" type="date" />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="audience_poll_duration"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Audience Poll Duration"
                  placeholder="60"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="expert_help_duration"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Expert Help Duration"
                  placeholder="60"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={6}>
            <Controller
              name="google_help_duration"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  label="Google Help Duration"
                  placeholder="60"
                  labelClasses="fs-7"
                  type="number"
                />
              )}
            />
          </Col>

          <Col sm={12}>
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  as="textarea"
                  label="Description"
                  labelClasses="fs-7"
                  placeholder="Add Here"
                  rows={8}
                />
              )}
            />
          </Col>
        </Row>
        <Button
          type="submit"
          text={"Submit"}
          classes="mt-2"
          isSubmitted={loading}
        />
      </Form>
    </Container>
  );
}
